import React from "react";
import { WidthProvider, Responsive } from "react-grid-layout";
import _ from "lodash";
import { uuid } from '../../functions'

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const item = (i, x, y, w, h) => ({
  i: i,
  x: x,
  y: y,
  w: w,
  h: h,
})

const removeStyle = {
  position: "absolute",
  right: "2px",
  top: 0,
  cursor: "pointer"
};

/**
 * This layout demonstrates how to use a grid with a dynamic number of elements.
 */
class AddRemoveLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.layout
    }
  }

  onAddItem() {
    this.setState({
      items: this.state.items.concat(
        item(
          uuid(),
          (this.state.items.length * 2) % (this.state.cols || 12),
          Infinity,
          2,
          2,
        )
      )
    })
  }

  onRemoveItem( i ) {
    this.setState({
      items: _.reject(this.state.items, { i: i })
    })
  }

  // We're using the cols coming back from this to calculate where to add new items.
  onBreakpointChange(breakpoint, cols) {
    this.setState({
      breakpoint: breakpoint,
      cols: cols
    })
  }

  createElement(el) {
    const Component = el.component || 'div'
    return (
      <div key={el.i} data-grid={el} style={{overflow:'hidden'}}>
        <span className="remove" style={removeStyle} onClick={_ => this.onRemoveItem(el.i)} >x</span>
          <Component />
      </div>
    )
  }

  onLayoutChange(layout) {
    //this.props.onLayoutChange(layout);
    this.setState({ layout: layout });
  }

  render() {
    return (
        <ResponsiveReactGridLayout
          onLayoutChange={e => this.props.onLayoutChange(e)}
          onBreakpointChange={(bp, cols) => this.onBreakpointChange(bp, cols)}
          {...this.props}
        >
          {_.map(this.state.items, el => this.createElement(el))}
        </ResponsiveReactGridLayout>
    )
  }
}

export { AddRemoveLayout }



// WEBPACK FOOTER //
// ./src/components/layout/AddRemoveLayout.jsx